import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const defaultState = {
  cart: {
    ids: [],
    qty: {},
  },
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ADD_PRODUCT': {
      return {
        ...state,
        cart: {
          ...state.cart,
          ids: !state.cart.ids.find((i) => i === action.productId)
            ? [...state.cart.ids, action.productId]
            : state.cart.ids,
          qty: {
            ...state.cart.qty,
            [action.productId]: (state.cart.qty[action.productId] || 0) + 1,
          },
        },
      };
    }
    case 'REMOVE_PRODUCT_ALL':
    case 'REMOVE_PRODUCT': {
      const nextQty =
        action.type === 'REMOVE_PRODUCT_ALL'
          ? 0
          : (state.cart.qty[action.productId] || 0) - 1;
      if (nextQty <= 0) {
        const next = { ...state.cart.qty };
        delete next[action.productId];
        return {
          ...state,
          cart: {
            ...state.cart,
            ids: state.cart.ids.filter((i) => i !== action.productId),
            qty: next,
          },
        };
      }

      return {
        ...state,
        cart: {
          ...state.cart,
          qty: {
            ...state.cart.qty,
            [action.productId]: nextQty,
          },
        },
      };
    }
    default:
  }
  return state;
};

const persistConfig = {
  key: '@@baleo-state',
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);
